<template>
  <div>
    <spin-while-loading
      v-if="isFiltersLoading"
      :dpsin="isFiltersLoading"
    ></spin-while-loading>
    <div
      class="
        w3-row
        cursor-pointer
        w3-center
        flow-margin-top flow-padding-top flow-padding-bottom
        tabs-container-head
      "
    >
      <form class="flow-form-cum-panel flow-card blue-top w3-col">
        <div class="w3-container flow-padding-top">
          <p class="w3-col w-45pc flow-form-inline-input">
            <label class="w3-left flow-blue-color flow-padding-bottom">{{
              $t("from")
            }}</label>
            <input
              v-bind:class="this.errors.startDateError ? 'error' : ''"
              class="w3-input"
              type="text"
              v-model="startDate"
              @blur="validateStartDate"
              placeholder="dd-mm-yyyy"
            />
            <span class="w3-text-red"> {{ errors.startDateError }} </span>
            <label
              class="w3-left flow-blue-color flow-padding-bottom"
              id="until-label"
              >{{ $t("until") }}</label
            >
            <input
              v-bind:class="this.errors.endDateError ? 'error' : ''"
              class="w3-input"
              type="text"
              v-model="endDate"
              @blur="validateEndDate"
              placeholder="dd-mm-yyyy"
            />
            <span class="w3-text-red"> {{ errors.endDateError }} </span>
          </p>
          <p class="w3-col w-45pc flow-form-inline-input">
            <label class="w3-left flow-blue-color flow-padding-bottom">{{
              $t("partOfTheName")
            }}</label>
            <input
              class="w3-input"
              v-bind:class="this.errors.nameError ? 'error' : ''"
              type="text"
              v-bind:placeholder="$t('enter.name')"
              v-model="name"
            />
            <span class="w3-text-red"> {{ errors.nameError }} </span>
          </p>
        </div>
        <div class="w3-container zero-top">
          <p class="w3-col w-45pc flow-form-inline-input">
            <label class="w3-left flow-blue-color flow-padding-bottom">{{
              $t("accessType")
            }}</label>
            <br />
            <span class="flowselect">
              <select v-model="accessType" id="filter-select">
                <option
                  v-for="items in selectValues"
                  :key="items.value"
                  :value="items.value"
                >
                  {{ $t(items.value) }}
                </option>
              </select>
              <i class="fa fa-chevron-down flow-green-active-color"></i>
            </span>
          </p>
        </div>
          <button
          class="
            flow-btn
            w3-btn
            w3-round
            w3-border
            w3-ripple
            w3-round-medium
            w3-margin-right
            w3-margin-top
            w3-large
          "
          @click.prevent="confirmFilters"
        >
          <i class="fa fa-search w3-text-green">
            <span
              ><b class="flow-margin-left">{{ $t("search") }}</b></span
            >
          </i>
        </button>

        <button
          class="
            flow-btn
            w3-btn
            w3-round
            w3-border
            w3-ripple
            w3-round-medium
            w3-margin-top
            w3-large
          "
          @click.prevent="clearFilters"
        >
          <i class="fa fa-times w3-text-red">
            <span
              ><b class="flow-margin-left">{{ $t("clearFilters") }}</b></span
            >
          </i>
        </button>

      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import SpinWhileLoading from "../common/Loading";
const frc = Vue.prototype.$frc;
export default {
  components: { SpinWhileLoading },
  props: ["searchWithFilters","defaultSearch"],
  data() {
    return {
      errors: { startDateError: "", endDateError: "", nameError: "" },
      validation: {start:true,end:true},
      startDate: "",
      endDate: "",
      name: "",
      selectValues: [],
      accessType: "",
      isFiltersLoading: false,
    };
  },
  mounted() {
    this.getAccessTypes();
  },
  methods: {
    getAccessTypes: function () {
      var app = this;
      app.isFiltersLoading = true;
      frc.getAllAccessControlTypes().then(function (res) {
        app.isFiltersLoading = false;
        app.selectValues = res.data;
        app.selectValues.unshift({ value: "" });
        app.accessType=app.selectValues[1].value;
      });
    },
    clearFilters() {
      this.resetFields();
      this.defaultSearch();
    },
      resetFields(){
        this.startDate = "";
        this.endDate = "";
        this.name = "";
        this.accessType = "";
      },
    confirmFilters() {
      var app = this;
      var queryParameters = {};
      if (this.startDate) {
        queryParameters.start = this.formatStartDate(this.startDate);
      }
      if (this.endDate) {
        queryParameters.end = this.formatEndDate(this.endDate);
      }
      if (this.accessType) {
        queryParameters.accessType = this.accessType;
      }
      if (this.name) {
        queryParameters.name = this.name;
      }
    if(this.checkValidation()){
      this.searchWithFilters(
        queryParameters.name,
        queryParameters.start,
        queryParameters.end,
        queryParameters.accessType
      );
    } else {
      Vue.notifyWarn({ title: app.$t("checkFormValues") });
    }
    },
    validateStartDate(){
      this.errors.startDateError = "";
      this.validation.start = true;
      if (this.startDate) {
        var dateString = this.startDate;
        if (dateString.length === 10) {
          var splitDate = dateString.split("-");
          if (
            splitDate.length === 3 &&
            splitDate[0].length === 2 &&
            splitDate[1].length === 2 &&
            splitDate[2].length === 4
          ) {
            var month = parseInt(splitDate[1]);
            var day = parseInt(splitDate[0]);

            if (month > 12 || day > 31) {
              this.errors.startDateError = this.$t("date_was_not_correct");
              this.validation.start = false;
            }
          } else {
            this.errors.startDateError = this.$t("invalid_date_format");
            this.validation.start = false;
          }
        } else {
          this.errors.startDateError = this.$t("invalid_date_format");
          this.validation.start = false;
        }
      }
    },
    validateEndDate(){
      this.errors.endDateError = "";
      this.validation.end = true;
      if (this.endDate) {
        var dateString = this.endDate;
        if (dateString.length === 10) {
          var splitDate = dateString.split("-");
          if (
            splitDate.length === 3 &&
            splitDate[0].length === 2 &&
            splitDate[1].length === 2 &&
            splitDate[2].length === 4
          ) {
            var month = parseInt(splitDate[1]);
            var day = parseInt(splitDate[0]);

            if (month > 12 || day > 31) {
              this.errors.endDateError = this.$t("date_was_not_correct");
              this.validation.end = false;
            }
          } else {
            this.errors.endDateError = this.$t("invalid_date_format");
            this.validation.end = false;
          }
        } else {
          this.errors.endDateError = this.$t("invalid_date_format");
          this.validation.end = false;
        }
      }
    },
    checkValidation() {
      this.validateStartDate();
      this.validateEndDate();
      for(const prop in this.validation){
        if(!this.validation[prop]){
          return false;
        }
      }
      return true;
    },
    formatEndDate(value) {
      var splitString = value.split("-");
      var string =
        splitString[2] +
        "-" +
        splitString[1] +
        "-" +
        splitString[0] +
        "T23:59:59";
      return string;
    },
    formatStartDate(value) {
      var splitString = value.split("-");
      return (
        splitString[2] +
        "-" +
        splitString[1] +
        "-" +
        splitString[0] +
        "T00:00:00"
      );
    },
  },
};
</script>


<style scoped>
#until-label {
  margin-top: 4px;
}
#filter-select {
  margin-top: 10px;
  width: 96%;
}
</style>